import { useEffect, useState } from "react";

const STORAGE_KEY = "demo.chatbot.enabled";
const EVENT_NAME = "demo.chatbot.change";

const readFlag = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
};

const writeFlag = (value: boolean) => {
    try {
        if (value) {
            localStorage.setItem(STORAGE_KEY, "1");
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch {
        // localStorage unavailable; nothing to persist
    }
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: value }));
};

export function useChatbotFlag(): [boolean, (next: boolean) => void] {
    const [enabled, setEnabled] = useState<boolean>(readFlag);

    useEffect(() => {
        const onChange = () => setEnabled(readFlag());
        window.addEventListener(EVENT_NAME, onChange);
        window.addEventListener("storage", onChange); // cross-tab
        return () => {
            window.removeEventListener(EVENT_NAME, onChange);
            window.removeEventListener("storage", onChange);
        };
    }, []);

    return [enabled, writeFlag];
}
